import { Expose, Transform, plainToClass } from "class-transformer";
import { Model } from "./model";
import { BaseStudent } from "./base-student-model";

export class UpgradeStudentsRequests extends Model {
    @Expose() id : string ;
    @Expose() student : BaseStudent;
}